<!-- NGX-SPINNER -->
<!-- <ngx-spinner type="ball-scale-multiple" size="medium"></ngx-spinner> -->


<ngx-spinner size="medium" type="square-jelly-box">
  <img src="assets/images/afp-1080.gif" width="350">
</ngx-spinner>
<!--PRIMENG GROWL NOTIFICATIONS GLOBAL-->
<app-notifications></app-notifications>

<!-- CONTEXT-SENSITIVE HELP (artist + gallery systems; self-gates by role) -->
<app-help-launcher></app-help-launcher>
<p-confirmDialog #cd [style]="{width: '30vw'}" [message]="'app.areYouSureProceed' | transloco" [header]="'app.confirmation' | transloco"
  icon="pi pi-exclamation-triangle">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="pi pi-times" [label]="'app.cancel' | transloco" class="p-button-secondary p-button-outlined"
    (click)="cd.reject()"></button>
    <button type="button" pButton icon="pi pi-check" [label]="'app.confirm' | transloco" class="p-button-success ms-2"
    (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

<!-- Loading state - shown while app is initializing.
     Never on a public artist website: the visitor is not an ArtFlow user and should not be shown
     ArtFlow's brand while the app boots. They get a neutral hold instead. -->
@if (!isAppReady && !isPublicSiteLoad) {
  <div class="app-loading-container">
    <div class="app-loading-content">
      <img src="assets/images/afp-1080.gif" width="200" [alt]="'app.loading' | transloco">
    </div>
  </div>
}
@if (!isAppReady && isPublicSiteLoad) {
  <div class="public-site-loading"></div>
}

<!-- Main app content - only shown after initialization is complete -->
@if (isAppReady) {
  <!--if the user is not logged-in or on an auth page, show plain layout-->
  @if (!isAuthenticated || isOnAuthPage) {
    <router-outlet></router-outlet>
  }
  <!-- NEW single-nav shell (role-aware: artist + gallery): top bar + icon rail + bottom bar -->
  @if (isAuthenticated && !isOnAuthPage && useNewShell) {
    <ds-shell>
      <router-outlet></router-outlet>
    </ds-shell>
  }
  <!-- Existing shell for everyone else (admin/judge/curator/event-only/impersonated) -->
  @if (isAuthenticated && !isOnAuthPage && !useNewShell) {
    <div class="row h-100 g-0 " id="srolbar">
      @if (!(isJudge || isCurator)) {
        <p-sidebar [(visible)]="sidebarVisible">
          <p>
            <app-sidebar [hideLogo]="true"></app-sidebar>
          </p>
        </p-sidebar>
      }
      @if (showSidebar && !(isJudge || isCurator)) {
        <div class="dsSidebarContainer border col-2 g-0">
          <app-sidebar></app-sidebar>
        </div>
      }
      <div [ngClass]="{'col-10': showSidebar && !(isJudge || isCurator), 'col-12': !showSidebar || isJudge || isCurator, 'dsMainContent': showSidebar && !(isJudge || isCurator) }"
        class="g-0 px-0">
        <!-- DS Header for Artists - inside content area (hidden for Judge/Curator) -->
        @if (isArtist && !isEventOnlyArtist && !isOnProfilePage && !isJudge && !isCurator) {
          <ds-header
            [chatmessages]="chatmessages"
            [notifications]="notifications"
            [countUnreadchatbox]="countUnreadchatbox"
            [countUnreadNotificaion]="countUnreadNotificaion"
            [isChatBoxMessagesShow]="isChatBoxMessagesShow"
            [isOnFreeTrial]="isOnFreeTrial"
            [hasFreeTrialEnded]="hasFreeTrailEnded ?? false"
            [remainingTime]="remainingTime"
            [isEventOnlyArtist]="isEventOnlyArtist"
            [showMessages]="showMessages"
            [showNotifications]="showNotifications"
            [isLoadingMessages]="isLoadingMessages"
            [isLoadingNotifications]="isLoadingNotifications"
            (toggleMessagesEvent)="toggleMessages($event)"
            (toggleNotificationsEvent)="toggleNotifications($event)"
            (chatWithUserEvent)="Chatwithuser($event)"
            (handleNotificationClickEvent)="handleNotificationClick($event)"
            (navigateToMessagesListEvent)="navigateToMessagesList()"
            (navigateToNotificationsListEvent)="navigateToNotificationsList()"
            (startFreeTrialEvent)="onStartFreeTrail()"
            (showUpgradeDialogEvent)="ShowUpgradeDailog()"
            (toggleSidebarEvent)="toggleSidebar()">
          </ds-header>
        }
        <!-- DS Header for Galleries - inside content area (hidden for Judge/Curator) -->
        @if (isGallery && !isOnProfilePage && !isJudge && !isCurator) {
          <ds-gallery-header
            [chatmessages]="chatmessages"
            [notifications]="notifications"
            [countUnreadchatbox]="countUnreadchatbox"
            [countUnreadNotificaion]="countUnreadNotificaion"
            [isChatBoxMessagesShow]="isChatBoxMessagesShow"
            [isOnFreeTrial]="isOnFreeTrial"
            [hasFreeTrialEnded]="hasFreeTrailEnded ?? false"
            [remainingTime]="remainingTime"
            [showMessages]="showMessages"
            [showNotifications]="showNotifications"
            [isLoadingMessages]="isLoadingMessages"
            [isLoadingNotifications]="isLoadingNotifications"
            (toggleMessagesEvent)="toggleMessages($event)"
            (toggleNotificationsEvent)="toggleNotifications($event)"
            (chatWithUserEvent)="Chatwithuser($event)"
            (handleNotificationClickEvent)="handleNotificationClick($event)"
            (navigateToMessagesListEvent)="navigateToMessagesList()"
            (navigateToNotificationsListEvent)="navigateToNotificationsList()"
            (startFreeTrialEvent)="onStartFreeTrail()"
            (showUpgradeDialogEvent)="ShowUpgradeDailog()"
            (toggleSidebarEvent)="toggleSidebar()">
          </ds-gallery-header>
        }
        <!-- DS Header for Admins - inside content area (hidden for Judge/Curator) -->
        @if ((isAdministrator || isSuperAdmin) && !viewingRoleAsAdmin && !isOnProfilePage && !isJudge && !isCurator) {
          <ds-admin-header
            [notifications]="notifications"
            [countUnreadNotificaion]="countUnreadNotificaion"
            [showNotifications]="showNotifications"
            [isLoadingNotifications]="isLoadingNotifications"
            [isSuperAdmin]="isSuperAdmin"
            [roles]="roles"
            [selectedRole]="selectedRole"
            [selectedEntity]="selectedEntity"
            [isDropdownOpen]="isDropdownOpen"
            [dropDownData]="dropDownData"
            [viewingRoleAsAdmin]="viewingRoleAsAdmin"
            (toggleNotificationsEvent)="toggleNotifications($event)"
            (handleNotificationClickEvent)="handleNotificationClick($event)"
            (navigateToNotificationsListEvent)="navigateToNotificationsList()"
            (selectRoleEvent)="onselectRole($event)"
            (selectIdEvent)="onselectedId($event)"
            (toggleSidebarEvent)="toggleSidebar()">
          </ds-admin-header>
        }
        <!-- Header for Judge/Curator roles - shown on all pages -->
        @if ((isJudge || isCurator) && !isOnProfilePage) {
          <div class="jc-header">
            <div class="jc-header-left">
              <img src="assets/images/thumb_AFP-logo-v02-noTagline-800.png" alt="ArtFlow Pro" class="jc-logo" />
              <span class="jc-panel-badge" [ngClass]="{'jc-role-judge': isJudge, 'jc-role-curator': isCurator}">
                <i class="fa" [ngClass]="{'fa-gavel': isJudge, 'fa-eye': isCurator}"></i>
                {{ isJudge ? 'Judge Panel' : 'Curator Panel' }}
              </span>
              @if (isOnReviewPage) {
                <button class="jc-back-btn" (click)="goBackToEvents()">
                  <i class="pi pi-arrow-left"></i> {{ 'app.backToEvents' | transloco }}
                </button>
              }
              @if (!isOnJudgeCuratorRoute && !isOnReviewPage) {
                <button class="jc-back-btn" (click)="goBackToEvents()">
                  <i class="pi pi-arrow-left"></i> {{ 'app.backToEvents' | transloco }}
                </button>
              }
            </div>
            <div class="jc-header-right">
              <div class="dropdown">
                <a class="nav-link dropdown-toggle jc-profile-toggle" href="#" role="button" data-bs-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                  @if (PersonalImgUrl == null) {
                    <i class="fa fa-user-circle-o fa-lg"></i>
                  }
                  @if (PersonalImgUrl != null) {
                    <img [src]="PersonalImgUrl" height="32" width="32"
                      class="rounded-circle" />
                  }
                  @if (!isSmallScreen) {
                    <span class="jc-user-name">{{ firstName }}</span>
                  }
                </a>
                <ul class="dropdown-menu dropdown-menu-end rounded-3 shadow" style="width: 260px;">
                  <div class="jc-dropdown-header">
                    <img [src]="userLogoUrl ? userLogoUrl : 'assets/images/thumb_AFP-logo-v02-noTagline-800.png'"
                      height="44" width="44" class="rounded-circle" />
                      <div>
                        <div class="fw-bold" style="font-size: 0.9rem;">{{ firstName }}</div>
                        <div class="text-muted" style="font-size: 0.78rem;">{{ UserEmail }}</div>
                      </div>
                    </div>
                    <li><hr class="dropdown-divider m-0"></li>
                    <a class="dropdown-item jc-signout-link" (click)="logout($event)">
                      <i class="fa fa-sign-out me-2 jc-signout-icon"></i>{{ 'app.signOut' | transloco }}
                    </a>
                  </ul>
                </div>
              </div>
            </div>
          }
          <!-- Switch Back Banner - visible when admin is viewing as Artist/Gallery -->
          @if (viewingRoleAsAdmin && (isAdministrator || isSuperAdmin)) {
            <div class="ds-switch-back-banner">
              <div class="ds-switch-back-content">
                <i class="fa fa-eye"></i>
                <span>{{ 'app.currentlyViewingAs' | transloco }} <strong>{{ selectedRole || 'another role' }}</strong></span>
                <button class="ds-switch-back-btn" (click)="exitRoleView($event)">
                  <i class="fa fa-arrow-left"></i> {{ 'app.switchBackToAdministrator' | transloco }}
                </button>
              </div>
            </div>
          }
          <div class="d-flex flex-column h-100" [ngClass]="{'mx-3 mt-2': !(isJudge || isCurator)}">
            <!-- Old burger icon - hidden when ds-header, ds-gallery-header, ds-admin-header, or judge/curator header has its own sidebar toggle -->
            @if ((!isArtist || isEventOnlyArtist || isOnProfilePage) && !isGallery && !isAdministrator && !isSuperAdmin && !isJudge && !isCurator) {
              <div class=" d-flex align-items-center justify-content-center text-center">
                <div class="burger-icon p-1" [class.d-none]="!isSmallScreen" (click)="toggleSidebar()">
                  <button pButton type="button" icon="pi pi-bars" class="p-button-rounded p-button-info fs-5"></button>
                </div>
              </div>
            }
            <!-- Old header bar - hidden when ds-header, ds-gallery-header, ds-admin-header, or judge/curator header is active -->
            @if (showSidebar && (!isArtist || isEventOnlyArtist) && !isGallery && !isAdministrator && !isSuperAdmin && !isJudge && !isCurator) {
              <div class="d-flex flex-wrap flex-md-nowrap justify-content-between align-items-center bg-dark-section">
                <div class=" d-flex align-items-center  justify-content-start ">
                  @if (!showSidebar) {
                    <div class="col-2 dsSidebarContainer g-0 w-100">
                      <img style="width: 260px;" class="cursor-pointer "
                        src="assets/images/thumb_AFP-logo-v02-noTagline-800.png" routerLink="/" [alt]="'app.logo' | transloco" />
                      </div>
                    }
                    @if (showSidebar) {
                      <div class="col-md-6 w-100 d-flex title  ">
                        @if (!isSmallScreen) {
                          <div class="logedin d-flex ">{{ 'app.youreLoggedInAs' | transloco: { name: firstName } }}
                            @if (BusinessName) {
                              <span class="small ms-2">
                                ({{ BusinessName }})
                              </span>
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                  <!-- <div class=" d-flex align-items-center" *ngIf="!showSidebar">
                  <span class="logedin ms-4">You're logged-in as {{ firstName }}</span>
                  <span *ngIf="BusinessName">
                    <span class="ms-2">({{ BusinessName }})</span>
                  </span>
                </div> -->
                <!-- Upgrade to Full Artist Button (Event-Only Artists) -->
                @if (isEventOnlyArtist) {
                  <app-upgrade-account></app-upgrade-account>
                }
                <!--if the user is not the pro user, give him an option to upgrade-->
                @if (isAdministrator || isSuperAdmin) {
                  <div class="d-flex align-items-center SwitchAccount">
                    <span class="me-2">{{ 'app.switchAccount' | transloco }}</span>
                    <p-dropdown [options]="roles" [(ngModel)]="selectedRole" [placeholder]="'app.selectAccountType' | transloco"
                      (onChange)="onselectRole($event)" class="p-1">
                      <ng-template let-group pTemplate="group">
                        <div class="flex align-items-center">
                          <span>{{ group.label }}</span>
                        </div>
                      </ng-template>
                    </p-dropdown>
                    @if (isDropdownOpen) {
                      <p-dropdown [options]="dropDownData" (onChange)="onselectedId($event)"
                        optionLabel="data.businessName" [filter]="true" filterBy="data.businessName" [showClear]="true"
                        [(ngModel)]="selectedRole" [placeholder]="getPlaceholderText()" class="p-1">
                        <ng-template let-group pTemplate="item">
                          <div class="flex align-items-center">
                            <img [src]="group.data?.imgUrl  ? group.data.imgUrl : 'assets/images/No-Image.png'"
                              class="rounded-circle " style="width: 25px; height: 25px;" />
                              <span [class]="group.data?.imgUrl" class="ms-2">
                                @if (!group.data?.businessName) {
                                  {{ group.label }}
                                }
                                @if (group.data?.businessName) {
                                  {{ group.data?.businessName }}
                                }
                              </span>
                            </div>
                          </ng-template>
                        </p-dropdown>
                      }
                    </div>
                  }
                  @if (viewingRoleAsAdmin) {
                    <div class="flex align-items-center logo-section"
                      [ngClass]="{'dashboardData_show': showDashboard, 'dashboardData_hide': !showDashboard}">
                      <button pButton type="button" class="p-button-outlined ml-2 Switchbackasadministrator"
                        [label]="'app.switchBackToAdministrator' | transloco" (click)="exitRoleView($event)" icon="fa fa-times">
                      </button>
                    </div>
                  }
                  @if (isOnFreeTrial && !isJudge && !isCurator) {
                    <div class="row d-flex align-items-center  logo-section">
                      <div class="col-md-6 w-100 d-flex align-items-center timer ">
                        <span>{{ 'app.freeTrialEndsIn' | transloco: { name: firstName } }}
                          @if (remainingTime?.display) {
                            {{ remainingTime.display }}
                          }
                        </span>
                        @if (!isFreePlanUser && !isEventOnlyArtist) {
                          <button pButton class="p-button-outlined p-button-sm btn-lightseagreen text-white ms-2"
                          (click)="upgradeToProAccount()">{{ 'app.upgradeNow' | transloco }}</button>
                        }
                      </div>
                    </div>
                  }
                  @if (isFreePlanUser && !isOnFreeTrial && !hasFreeTrailEnded && !isEventOnlyArtist && !(isAdministrator || isSuperAdmin) && !isJudge && !isCurator) {
                    <div class="free-trial yourfreetrail ">
                      <img src="assets/images/free-trial.png" alt=""
                        [ngClass]="{'dashboardData_show': showDashboard, 'dashboardData_hide': !showDashboard}"
                        icon="fa fa-gift" (click)="onStartFreeTrail()" />
                      </div>
                    }
                    <div class="logo-section">
                      @if (!isSuperAdmin && !isAdministrator && !isEventOnlyArtist && isFreePlanUser && !isJudge && !isCurator && (isOnFreeTrial && !hasFreeTrailEnded || hasFreeTrailEnded || !isOnFreeTrial && !hasFreeTrailEnded)) {
                        <a href="javascript:void(0);" (click)="ShowUpgradeDailog()">
                          <img src="assets/images/upgrade-nag-button-200h.png" height="40" />
                        </a>
                      }
                    </div>
                    <!-- ADD CLASS dsUserIcon -->
                    <div class="d-flex pe-3 dsUserIcon d-flex align-items-center">
                      <div class="d-flex align-items-center me-1 justify-content-between last-sections">
                        <!-- Messages Section (Messenger Icon) -->
                        @if (!isSuperAdmin && !isAdministrator) {
                          <div class="notification-container">
                            @if (isChatBoxMessagesShow) {
                              <button (click)="toggleMessages($event)" class="notification-icon  p-1">
                                <i class="fa fa-comments"></i> <!-- Messenger Icon -->
                                @if (countUnreadchatbox) {
                                  <span class="badge">{{ countUnreadchatbox }}</span>
                                }
                              </button>
                            }
                            @if (showMessages) {
                              <div class="notification-list">
                                <!-- Loader -->
                                @if (isLoadingMessages) {
                                  <div class="text-center p-3">
                                    <i class="fa fa-spinner fa-spin text-light fs-3"></i>
                                  </div>
                                }
                                @for (message of chatmessages.slice(0, 5); track message) {
                                  <div class="notification-item">
                                    <div class="notification-text" (click)="Chatwithuser(message)">
                                      <div class="d-flex align-items-center justify-content-between">
                                        <div class="d-flex align-items-center">
                                          <img [src]="message.SenderImgUrl ? message.SenderImgUrl : 'assets/images/No-Image.png'"
                                            [alt]="'app.user' | transloco" class="notification-avatar">
                                            <div class="title fw-bold ms-2">
                                              {{ message.SenderUserName }}
                                              @if (message.UnreadCount) {
                                                <span class="badge unread-count ms-1">{{ message.UnreadCount
                                                }}</span>
                                              }
                                            </div>
                                          </div>
                                          <small class="time">{{ message.LastMessageTime | date:'short' }}</small>
                                        </div>
                                        <div class="subtitle mt-1">{{ message.LastMessageTitle }}</div>
                                        <p class="body">{{ message.LastMessageBody | slice:0:80 }}...</p>
                                      </div>
                                    </div>
                                  }
                                  @if (chatmessages.length > 4) {
                                    <div class="see-all">
                                      <a (click)="navigateToMessagesList()">{{ 'app.seeAll' | transloco }}</a>
                                    </div>
                                  }
                                  @if (chatmessages.length == 0) {
                                    <div class="p-3 py-3">
                                      {{ 'app.noMessagesFound' | transloco }}
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          }
                          <!-- Notifications Section (Bell Icon) -->
                          @if (!isSuperAdmin && !isAdministrator) {
                            <div class="notification-container ms-3">
                              <button (click)="toggleNotifications($event)" class="notification-icon p-1">
                                <i class="fa fa-bell"></i> <!-- Bell Icon -->
                                @if (countUnreadNotificaion) {
                                  <span class="badge">{{ countUnreadNotificaion }}</span>
                                }
                              </button>
                              @if (showNotifications) {
                                <div class="notification-list">
                                  <!-- Loader -->
                                  @if (isLoadingNotifications) {
                                    <div class="text-center p-3">
                                      <i class="fa fa-spinner fa-spin text-light fs-3"></i>
                                    </div>
                                  }
                                  @for (notification of notifications.slice(0, 5); track notification) {
                                    <div class="notification-item"
                                      (click)="handleNotificationClick(notification)">
                                      <div class="notification-text">
                                        <div class="d-flex align-items-center justify-content-between">
                                          <div class="d-flex align-items-center">
                                            <i class="fa me-2"
                                            [ngClass]="{'fa-bell text-success': notification.IsRead, 'fa-bell-slash text-danger': !notification.IsRead}"></i>
                                            <div class="title fw-bold">
                                              {{ notification.SenderUserName }}
                                            </div>
                                          </div>
                                          <small class="time">{{ notification.CreatedAt | date:'short' }}</small>
                                        </div>
                                        <div class="subtitle mt-1">{{ notification.Title }}</div>
                                        <p class="body">{{ notification.Body | slice:0:80 }}...</p>
                                      </div>
                                    </div>
                                  }
                                  @if (notifications.length > 5) {
                                    <div class="see-all">
                                      <a (click)="navigateToNotificationsList()">{{ 'app.seeAll' | transloco }}</a>
                                    </div>
                                  }
                                  @if (notifications.length == 0) {
                                    <div class="p-3 py-3">
                                      {{ 'app.noNotificationsFound' | transloco }}
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          }
                        </div>
                        <div class="dropdown ms-3">
                          <a class="nav-link dropdown-toggle fw-bolder" href="#" role="button" data-bs-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false"
                            [ngClass]="{'dashboardData_show': showDashboard, 'dashboardData_hide': !showDashboard}">
                            @if (PersonalImgUrl == null) {
                              <i class="fa fa-user-circle-o fa-lg"></i>
                            }
                            @if (PersonalImgUrl != null) {
                              <img [src]="PersonalImgUrl" height="30" width="30"
                                class="rounded-circle" />
                            }
                          </a>
                          <div class="w-100">
                            <ul class="dropdown-menu rounded-3 shadow p-3" style="width: 350px;">
                              <!-- User Info Section -->
                              <div class="row align-items-center mb-3">
                                <div class="col-3 text-center">
                                  <li class="dropdown-item p-0">
                                    <a href="javascript:void(0);" routerLink="/" class="d-block">
                                      <img [src]="userLogoUrl ? userLogoUrl : 'assets/images/thumb_AFP-logo-v02-noTagline-800.png'"
                                        height="60" width="60" class="rounded-circle" />
                                      </a>
                                    </li>
                                  </div>
                                  <div class="col-9">
                                    <div class="fw-bold fs-5">{{ firstName }}</div>
                                    <div class="text-muted small">{{ UserEmail }}</div>
                                  </div>
                                </div>
                                <!-- Plan Section (Hidden for Judge/Curator) -->
                                @if ((isArtist || isGallery) && !isJudge && !isCurator) {
                                  <li class="dropdown-item p-2">
                                    <div class="d-flex justify-content-between align-items-center bg-dark text-white p-2 rounded">
                                      <div class="d-flex align-items-center">
                                        <span>{{ 'app.yourPlan' | transloco }}</span>
                                        <span class="ms-2">
                                          @if (isArtist) {
                                            @if (isFreePlanUser) {
                                              {{ 'app.artistFree' | transloco }}
                                            }
                                            @if (!isFreePlanUser) {
                                              {{ 'app.artistPro' | transloco }}
                                            }
                                          }
                                          @if (isGallery) {
                                            @if (isFreePlanUser) {
                                              {{ 'app.galleryFree' | transloco }}
                                            }
                                            @if (!isFreePlanUser) {
                                              {{ 'app.galleryPro' | transloco }}
                                            }
                                          }
                                        </span>
                                      </div>
                                      @if (!isAdministrator && !isEventOnlyArtist && isFreePlanUser) {
                                        <div>
                                          <a href="javascript:void(0);" (click)="ShowUpgradeDailog()">
                                            <img src="assets/images/upgrade-pro.png" height="40" />
                                          </a>
                                        </div>
                                      }
                                    </div>
                                  </li>
                                }
                                <!-- Member Since Section (Hidden for Judge/Curator) -->
                                @if (!isAdministrator && !isJudge && !isCurator) {
                                  <div class="d-flex justify-content-between align-items-center mt-2 mb-2">
                                    <span class="fw-bold ms-3">{{ 'app.memberSince' | transloco }}</span>
                                    <span>{{ memberSince | date: 'dd-MMM-yyyy' }}</span>
                                  </div>
                                }
                                <!-- Navigation Links (Hidden for Judge/Curator) -->
                                @if (!isJudge && !isCurator) {
                                  <div class="dropdown">
                                    <a class="dropdown-item py-2" routerLink="/edit-profile">{{ 'app.myProfile' | transloco }}</a>
                                    @if (isArtist) {
                                      <a class="dropdown-item py-2" [routerLink]="['/artists', 'connected-galleries']">{{ 'app.myGalleries' | transloco }}</a>
                                    }
                                    @if (isArtist) {
                                      <a class="dropdown-item py-2" [routerLink]="['/artists', 'artworks']">{{ 'app.myArtworks' | transloco }}</a>
                                    }
                                    @if ((isArtist || isGallery) && !isFreePlanUser && proBySource !== proBySourceEnum.Artflow && proBySource !== proBySourceEnum.FreeTrial) {
                                      <a class="dropdown-item py-2" [routerLink]="['/user-invoice']">{{ 'app.mySubscriptions' | transloco }}</a>
                                    }
                                  </div>
                                }
                                <!-- Divider -->
                                <li class="dropdown-item p-0">
                                  <div class="dropdown-divider"></div>
                                </li>
                                <!-- Account Actions -->
                                <div class="dropdown">
                                  @if (!isAdministrator) {
                                    <a class="dropdown-item py-2 cursor-pointer" [routerLink]="['/request-deletion']"
                                      >{{ 'app.deleteAccount' | transloco }}</a>
                                  }
                                  <a class="dropdown-item py-2 cursor-pointer" (click)="logout($event)">{{ 'app.signOut' | transloco }}</a>
                                </div>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                    <div class="flex-grow-1 h-100" [ngClass]="{'mt-2': !(isJudge || isCurator)}">
                      <router-outlet></router-outlet>
                    </div>
                  </div>
                </div>
              </div>
            }
          }

          <!-- <footer class="container-footer w-100 mt-5">
          <div class="d-flex justify-content-center align-items-center h-100">
            ArtFlow - Developed for Artists & Galleries by info-onscreen &copy; 2023. All rights reserved.
          </div>
        </footer> -->

        <!-- Stripe Checkout Dialog Component -->
        @if (isStripeDisplayPlansDialogVisible) {
          <stripe-payment-plan [isStripePaymentPlansDialogVisible]="isStripeDisplayPlansDialogVisible"
          (onCloseStripePaymentPlanDailog)="onCloseStripePaymentDailog($event)"></stripe-payment-plan>
        }
        <p-dialog [(visible)]="isStripeCheckoutSuccessDialogVisible" [modal]="true"
          (onHide)="onCloseStripeCheckoutCompleteDailog()" [style]="{ 'width': '430px'}">
          <div class="d-flex flex-column align-items-center px-3 py-3 text-center">
            <img src="assets/images/tik-image.jpg" [alt]="'app.success' | transloco" class="img-fluid rounded-circle" style="width: 100px;">
            <div class="h5 my-4 text-secondary">{{ 'app.congratulationsUpgraded' | transloco }}</div>
          </div>
        </p-dialog>

        @if (authConfig?.IsArtist) {
          <app-free-trial-feature-dialog [FreeTrialFeatureDialogVisible]="FreeTrialFeatureDialogVisible"
            (onclose)="handleDialogClose($event)">
          </app-free-trial-feature-dialog>
        }

<!-- Build version badge — visible on every page (all roles, logged-in & out). Hover for full build detail. -->
<div class="app-version-badge"
  title="commit {{ buildInfo.commit }} · built {{ buildInfo.timestamp | date:'dd-MMM-yyyy HH:mm' }}">
  {{ buildInfo.version }}.{{ buildNumberLabel }} : {{ buildInfo.timestamp | date:'dd-MMM-yyyy HH:mm' }}
</div>